import { OpaqueToken } from '@angular/core';

export const DATASTORE_CONFIG = new OpaqueToken('DatastoreConfig');



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/datastore/datastore.config.ts